import { GameVars } from "./../../../GameVars";
import { Slider } from "./Slider";
import { GUI } from "./GUI";
import { Button } from "../../../utils/Button";
import { GameConstants } from "../../../GameConstants";
import { RoomManager } from "../../../managers/RoomManager";
import { AudioManager } from "../../../managers/AudioManager";

export class BetButtons extends Phaser.GameObjects.Container {

    private foldButton: Phaser.GameObjects.Container;
    private checkButton: Phaser.GameObjects.Container;
    private allInButton: Phaser.GameObjects.Container;
    private callButton: Phaser.GameObjects.Container;
    private raiseButton: Phaser.GameObjects.Container;
    private callButtonLabel: Phaser.GameObjects.Text;
    private raiseButtonLabel: Phaser.GameObjects.Text;
    private slider: Slider;
    private gui: GUI;

    constructor(scene: Phaser.Scene, gui: GUI) {

        super(scene);

        this.scaleX = GameVars.scaleX;
        this.y = GameConstants.GAME_HEIGHT;

        this.gui = gui;

        // FOLD

        this.foldButton = new Phaser.GameObjects.Container(this.scene, 160, -50);
        this.add(this.foldButton);

        const foldButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_blue.png", "btn_blue.png", true);
        foldButton.onUp(this.onClickFold, this);
        this.foldButton.add(foldButton);

        const foldLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, "FOLD", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#064150", align: "center"});
        foldLabel.setOrigin(.5);
        this.foldButton.add(foldLabel); 

        // CHECK

        this.checkButton = new Phaser.GameObjects.Container(this.scene, 310, -50);
        this.add(this.checkButton);

        const checkButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        checkButton.onUp(this.onClickCheck, this);
        this.checkButton.add(checkButton);

        const checkLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, "CHECK", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#6D3624", align: "center"});
        checkLabel.setOrigin(.5);
        this.checkButton.add(checkLabel);

        // ALL IN
        this.allInButton = new Phaser.GameObjects.Container(this.scene, 310, -50);
        this.add(this.allInButton);

        const allInButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_red.png", "btn_red.png", true);
        allInButton.onUp(this.onClickAllIn, this);
        this.allInButton.add(allInButton);

        const allInLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, "ALL IN", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#871947", align: "center"});
        allInLabel.setOrigin(.5);
        this.allInButton.add(allInLabel);

        // CALL
        this.callButton = new Phaser.GameObjects.Container(this.scene, 310, -50);
        this.add(this.callButton);

        const callButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        callButton.onUp(this.onClickCall, this);
        this.callButton.add(callButton);

        const callLabel = new Phaser.GameObjects.Text(this.scene, 0, -15, "CALL", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#6D3624", align: "center"});
        callLabel.setOrigin(.5);
        this.callButton.add(callLabel);

        this.callButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 15, GameVars.callValue.toString(), {fontFamily: "Oswald-Medium", fontSize: "32px", color: "#40241B"});
        this.callButtonLabel.setOrigin(.5);
        this.callButton.add(this.callButtonLabel); 

        // SLIDER
        this.slider = new Slider(this.scene, this);
        this.add(this.slider);

        // RAISE
        this.raiseButton = new Phaser.GameObjects.Container(this.scene, 460, -50);
        this.add(this.raiseButton);

        const raiseButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_red.png", "btn_red.png", true);
        raiseButton.onUp(this.onClickRaise, this);
        this.raiseButton.add(raiseButton);

        const raiseLabel = new Phaser.GameObjects.Text(this.scene, 0, -15, "RAISE TO", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#871947", align: "center"});
        raiseLabel.setOrigin(.5);
        this.raiseButton.add(raiseLabel);

        this.raiseButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 15, GameVars.raiseValue.toString(), {fontFamily: "Oswald-Medium", fontSize: "32px", color: "#40241B"});
        this.raiseButtonLabel.setOrigin(.5);
        this.raiseButton.add(this.raiseButtonLabel);

        const widthMax = (this.slider.x + this.slider.sliderWidth + 10 + 80) * GameVars.scaleX;
        this.x = GameConstants.GAME_WIDTH / 2 - widthMax / 2;
    }

    public setValues(): void {

        if (!RoomManager.getPlayer(GameVars.playerId)) {
            return;
        }

        if (GameVars.gameState.call >= RoomManager.getPlayer(GameVars.playerId).wagered + RoomManager.getPlayer(GameVars.playerId).chips) {
            this.foldButton.visible = true;
            this.callButton.visible = false;
            this.checkButton.visible = false;
            this.allInButton.visible = true;
            this.raiseButton.visible = false;
            this.slider.visible = false;
        } else if (GameVars.gameState.call === RoomManager.getPlayer(GameVars.playerId).wagered) {
            this.foldButton.visible = false;
            this.callButton.visible = false;
            this.checkButton.visible = true;
            this.allInButton.visible = false;
            this.raiseButton.visible = true;
            this.slider.visible = true;
        } else {
            this.foldButton.visible = true;
            this.callButton.visible = true;
            this.checkButton.visible = false;
            this.allInButton.visible = false;
            this.raiseButton.visible = true;
            this.slider.visible = true;
        }  

        let max = RoomManager.getPlayer(GameVars.playerId).chips;
        let min = Math.min(max, GameVars.gameState.raise);

        this.raiseButtonLabel.text = min.toString();
        this.callButtonLabel.text = (GameVars.gameState.call - RoomManager.getPlayer(GameVars.playerId).wagered).toString();
    }

    public setBetValue(bet: number): void {

        this.raiseButtonLabel.text = bet.toString();
    }

    public acivate(): void {

        this.visible = true;
        this.slider.toMinimum();
    }

    public deactivate(): void {

        this.visible = false;
    }

    private onClickFold(): void {

        AudioManager.playSound("btn_click");
        
        this.deactivate();
        RoomManager.playerBet(0);

        if (Math.random() < .1) {
            RoomManager.showBananaPopcorns();
        }
        
        this.gui.showSkip();
        
    }

    private onClickCheck(): void {

        AudioManager.playSound("btn_click");
        
        this.deactivate();
        RoomManager.playerBet(0);
        
    }

    private onClickAllIn(): void {

        AudioManager.playSound("btn_click");
        
        this.deactivate();
        RoomManager.playerBet(RoomManager.getPlayer(GameVars.playerId).chips);
        
    }

    private onClickCall(): void {

        AudioManager.playSound("btn_click");
        
        this.deactivate();
        RoomManager.playerBet(parseInt(this.callButtonLabel.text) + RoomManager.getPlayer(GameVars.playerId).wagered);
        
    }

    private onClickRaise(): void {

        AudioManager.playSound("btn_click");
        
        this.deactivate();
        RoomManager.playerBet(Math.min(parseInt(this.raiseButtonLabel.text), RoomManager.getPlayer(GameVars.playerId).chips));
    }
}
